export enum EavParent {
    EXAM_CENTER = "EXAM_CENTER",
    SCREENING_UNIT = "SCREENING_UNIT",
}

export enum EavClassName {
    EXAM_CENTER_PARAM = "EXAM_CENTER_PARAM",
    MEETING = "MEETING",
}

export enum EavAttributeName {
    USE_EQUESTIONNAIRE = "USE_EQUESTIONNAIRE",
    HIDE_LONG_APT_REASON = "HIDE_LONG_APT_REASON",
}
